<template>
    <div class="area-item"
        :class="theme"
        @click="clickHistory()">
        <div class="area-item-img">
            <div class="history-img">
                <img :src="item.fullImageUrl" />
            </div>
        </div>
        <div class="area-item-detail"
            :class="[{'mass': theme == 'mass'}, {'prestige': theme == 'prestige'}]">
            <div class="item-detail-header">
                {{item.name}}
            </div>
            <div class="item-detail-body">
                <p>{{getRedeemDate()}}</p>
                <p v-if="checkCountDown()">{{getExpireDate()}}</p>
            </div>
            <div class="item-detail-footer">
                <div class="item-status"
                    :class="[{'status-active': item.isAvailable && (info && info[0] != 'type_transfer' || info == null)},
                    {'status-active': item.status == 'used' && item.extension.Group == '1'},
                    {'status-used': !item.isAvailable && item.status == 'used' && item.extension.Group != '1'},
                    {'status-cancelled': !item.isAvailable && item.status == 'cancelled'},
                    {'status-expired': !item.isAvailable && item.status == 'expired'},
                    {'status-refill': item.isAvailable && item.status == 'refill'},
                    {'status-draw': !item.isAvailable && item.status == 'draw'},
                    {'status-transfered': item.isAvailable && (item.status == 'used' && info && info[0] == 'type_transfer')},
                    {'status-min-match': item.isMinPrivilegeMatch == null || !item.isMinPrivilegeMatch}]" v-html="getStatus()">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import Moment from "moment";
//helper
import Locale from "@/helper/locale/locale.js";
import Util from "@/helper/Utility.js";
export default {
    name: "ListItem",
    computed: {
        theme: function() {
            return this.$store.state.theme;
        }
    },
    props: {
        lbl: Object,
        item: Object,
        itemIndex: Number,
        historyController: Object,
        modalController: Object
    },
    data: function () {
        return {
            isUsed: false,
            infoTransfer: null,
            info: null
        };
    },
    created: function () {
        this.isUsed = this.historyController.isUsed;
        this.infoTransfer = this.item.info1;
        if (this.infoTransfer) {
            this.info = this.infoTransfer.split('|');
        }
        console.log('item',this.item);
    },
    methods: {
        //event
        clickHistory: function () {
            if (!this.item.isClickable) return;
            // if (this.info && this.info[0] == 'type_transfer') return;
            if (this.item.extension.Group == 8){
                if (this.item.extension.Info) {
                    return;
                }
            }

            this.historyController.getHistoryInfo(this.itemIndex, this.item.redeemKey);
        },
        //util
        dateFormatter: function (timestamp) {
            var result = Moment.unix(timestamp).utc();

            var year = (Locale.getLocaleCode() === 1054) ? result.get('year') + 543 : result.get('year');

            var month = this.lbl.date.month_short[result.format('MM') - 1];
            var day = result.format('DD');
            return `${day} ${month} ${year}`;
        },
        checkCountDown: function () {
            if (this.item.extension && this.item.extension.Group == '4') {
                return false;
            }

            if (this.item.type == Vue.CampaignType.Buy
                || this.item.type == Vue.CampaignType.Free
                || this.item.type == Vue.CampaignType.Deal) {
                return !(this.item.minutesValidAfterUsed && this.item.minutesValidAfterUsed > 0);
            }
        },
        getExpireDate: function () {
            if (!this.item.expireDate) return;

            var date = this.dateFormatter(this.item.expireDate);
            return Util.stringFormat(this.lbl.purchase.expire_date, date);
        },
        getRedeemDate: function () {
            if (!this.item.redeemDate) return;

            var date = this.dateFormatter(this.item.redeemDate);

            return Util.stringFormat(this.lbl.purchase.redeem_date, date);
        },
        getStatus: function () {
            var status_txt = '';
            if (!this.item.isAvailable) {
                switch (this.item.status) {
                    case 'used':
                        if (this.item.extension.Group == '1' || this.item.extension.Group == 1) {
                            status_txt = this.lbl.purchase.status_available;
                        } else {
                            status_txt= this.lbl.purchase.status_used;
                        }
                        break;
                    case 'expired':
                        status_txt = this.lbl.purchase.status_expired;
                        break;
                    case 'cancelled':
                        status_txt = this.lbl.purchase.status_cancelled;
                        break;
                }
            } else {
                if (!this.item.isMinPrivilegeMatch || this.item.isMinPrivilegeMatch == null) {
                    status_txt = this.lbl.purchase.status_min_match;
                } else {
                    status_txt = this.lbl.purchase.status_available;
                    if (this.item.status == 'refill'){
                        status_txt = this.lbl.purchase.status_refill;
                    } else if(this.item.status == 'used' && this.info && this.info[0] == 'type_transfer'){
                        console.log('in else if');
                        if (this.info.length >= 0) {
                            status_txt = this.lbl.purchase.status_transfered;
                        }
                    }
                }
                
            }

            if (this.item.status == 'draw') {
                if (this.item.isDrawAnnounce) {
                    status_txt = (this.item.isDrawWinner) ? this.lbl.purchase.draw_winner : this.lbl.purchase.draw_not_win;
                } else {
                    status_txt = this.lbl.purchase.not_draw;
                }
            }

            if (this.item.website && this.item.website.indexOf('wondd') >= 0) {
                status_txt = "";
            }

            if (this.item.extension.Group == 8) {
                if (!this.item.extension.Info) {
                    status_txt = this.lbl.purchase.status_group_8;
                } else {
                    status_txt = "";
                }
            }
            return status_txt;
        }
    }
};
</script>
<style lang="scss">
@import "./style/ListItem.scss";
</style>
